export const ArrowLeft = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M14 26L15.41 24.59L7.83 17H28V15H7.83L15.41 7.41L14 6L4 16L14 26Z" fill="currentColor"/>
<path d="M13.7086 25.4085L4.41101 15.9983L13.6751 6.67892" stroke="currentColor" stroke-width="2"/>
<path d="M27 15.9929L5 15.9929" stroke="currentColor" stroke-width="2"/>
</svg>`;
